import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var SailboatIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsxs("g", {
                            clipPath: "url(#sailboat__a)",
                            children: [
                                _jsx("path", {
                                    d: "M23.173 15.41a.997.997 0 00-.82-.43h-10.15V1.61c0-.07-.02-.14-.04-.21-.02-.06-.02-.12-.05-.17a.653.653 0 00-.1-.15c-.04-.06-.08-.12-.13-.17l-.03-.03c-.04-.03-.08-.04-.12-.06-.06-.04-.12-.08-.19-.1-.07-.02-.13-.03-.2-.04-.05 0-.09-.03-.14-.03h-.04c-.07 0-.13.02-.2.04-.06.02-.12.02-.17.05-.05.02-.1.06-.15.1-.06.04-.12.08-.17.13l-.03.03-7.97 9.56a1 1 0 00.77 1.64h6.96v2.78h-8.55a1.005 1.005 0 00-.94 1.35l1.59 4.3a4.177 4.177 0 003.92 2.72h11.51c.88-.02 1.69-.25 2.39-.74.71-.49 1.24-1.17 1.54-1.97l1.62-4.3c.12-.31.07-.65-.11-.92v-.01zM5.383 10.2l4.83-5.79v5.79h-4.83zm14.41 9.72c-.16.42-.44.78-.8 1.03-.37.25-.8.39-1.25.39H6.233a2.1 2.1 0 01-1.24-.39c-.37-.26-.65-.61-.8-1.03l-1.09-2.95h17.81l-1.11 2.95h-.01z"
                                }),
                                _jsx("path", {
                                    d: "M13.392 11.2c0 .55.45 1 1 1h5.57c.39 0 .75-.23.91-.59.16-.36.1-.78-.16-1.07l-5.57-6.37a.99.99 0 00-1.41-.09c-.42.36-.46 1-.09 1.41l4.12 4.71h-3.37c-.55 0-1 .45-1 1z"
                                })
                            ]
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "sailboat__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
SailboatIcon.isCarinaIcon = true;
export default SailboatIcon;
